import { apolloClientPublic, unwrapGraphqlResponse } from '@src/utils/graphql'
import { loginRoute, failRoute, homeRoute } from '@src/router'
import { backUrl, fakeUser } from '@src/config'
import gql from 'graphql-tag'

export const authUserQuery = gql`
  query {
    whoami {
      id
      firstname
      lastname
      fullname
      email
      isAdmin
    }
  }
`
export const loginUri = 'oidc/authenticate?next=%nextURI%&fail=%failURI%'
export const logoutUri = 'oidc/logout?next=%nextURI%&fail=%failURI%'

export async function checkAuth () {
  if (fakeUser) {
    return Promise.resolve({ fullname: 'Mock user' })
  } else {
    return unwrapGraphqlResponse(
      apolloClientPublic.query({ query: authUserQuery }),
    ).then(({ whoami }) => whoami).catch(error => {
      console.error(error)
      return null
    })
  }
}

export function login (Window) {
  Window = Window || window
  const nextURI = `${Window.location.protocol}//${Window.location.host}${homeRoute.path}`
  const failURI = `${Window.location.protocol}//${Window.location.host}${failRoute.path}`
  if (fakeUser) {
    Window.location.replace(nextURI)
  } else {
    Window.location.replace(
      backUrl + loginUri.replace(
        '%nextURI%', encodeURIComponent(nextURI),
      ).replace(
        '%failURI%', encodeURIComponent(failURI),
      ),
    )
  }
}

export function logout (Window) {
  Window = Window || window
  const nextURI = `${Window.location.protocol}//${Window.location.host}${loginRoute.path}`
  const failURI = `${Window.location.protocol}//${Window.location.host}${failRoute.path}`
  if (fakeUser) {
    Window.location.replace(nextURI)
  } else {
    Window.location.replace(
      backUrl + logoutUri.replace(
        '%nextURI%', encodeURIComponent(nextURI),
      ).replace(
        '%failURI%', encodeURIComponent(failURI),
      ),
    )
  }
}
